module.exports = __webpack_public_path__ + "img/spye-banner-1.e53095bd.png";